import { useNavigate } from 'react-router-dom';

function EcosystemSection() {
  const navigate = useNavigate();

  const modules = [
    {
      name: 'Média',
      path: '/media',
      description: 'Vidéos, musiques et créations de la communauté.',
      icon: 'ri-film-line',
      color: 'text-accent-400',
      bg: 'bg-accent-500/10',
    },
    {
      name: 'Shop',
      path: '/shop',
      description: 'Achetez. Vendez. En toute confiance.',
      icon: 'ri-shopping-bag-3-line',
      color: 'text-primary-400',
      bg: 'bg-primary-500/10',
    },
    {
      name: 'Work',
      path: '/work',
      description: 'Trouvez des talents. Réalisez vos projets.',
      icon: 'ri-briefcase-4-line',
      color: 'text-accent-400',
      bg: 'bg-accent-500/10',
    },
    {
      name: 'Jobs',
      path: '/jobs',
      description: 'Emplois et opportunités de carrière.',
      icon: 'ri-id-card-line',
      color: 'text-secondary-400',
      bg: 'bg-secondary-500/10',
    },
    {
      name: 'Learn',
      path: '/learn',
      description: 'Apprenez. Progressez. Évoluez.',
      icon: 'ri-graduation-cap-line',
      color: 'text-primary-400',
      bg: 'bg-primary-500/10',
    },
    {
      name: 'Apartments',
      path: '/apartments',
      description: 'Louez, achetez, investissez dans l\'immobilier.',
      icon: 'ri-home-4-line',
      color: 'text-secondary-400',
      bg: 'bg-secondary-500/10',
    },
    {
      name: 'Pay',
      path: '/pay',
      description: 'Payez. Recevez. Gérez. Simplement.',
      icon: 'ri-wallet-3-line',
      color: 'text-accent-400',
      bg: 'bg-accent-500/10',
    },
    {
      name: 'Forum',
      path: '/forum',
      description: 'Communauté. Partage. Échange.',
      icon: 'ri-discuss-line',
      color: 'text-secondary-400',
      bg: 'bg-secondary-500/10',
    },
    {
      name: 'Cloud',
      path: '/cloud',
      description: 'Hébergement. Stockage. Sauvegarde.',
      icon: 'ri-cloud-line',
      color: 'text-primary-400',
      bg: 'bg-primary-500/10',
    },
    {
      name: 'AI',
      path: '/ai',
      description: 'Intelligence Artificielle au service de votre business.',
      icon: 'ri-brain-line',
      color: 'text-accent-400',
      bg: 'bg-accent-500/10',
    },
    {
      name: 'Blog',
      path: '/blog',
      description: 'Idées, conseils et actualités.',
      icon: 'ri-article-line',
      color: 'text-primary-400',
      bg: 'bg-primary-500/10',
    },
    {
      name: 'FAQ',
      path: '/faq',
      description: 'Réponses à toutes vos questions.',
      icon: 'ri-question-line',
      color: 'text-secondary-400',
      bg: 'bg-secondary-500/10',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-sm font-semibold text-primary-400 uppercase tracking-wider mb-3">
            Écosystème
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-50 mb-4">
            Un écosystème complet et connecté
          </h2>
          <p className="text-base md:text-lg text-foreground-400 max-w-2xl mx-auto">
            Tous les outils dont vous avez besoin, au même endroit. Connecter, Créer, Apprendre, Réussir.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {modules.map((module) => (
            <button
              key={module.name}
              onClick={() => navigate(module.path)}
              className="group text-left p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-400/40 transition-all duration-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${module.bg} mb-4`}>
                <i className={`${module.icon} text-2xl ${module.color}`} />
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-50 mb-2">
                {module.name}
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {module.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity">
                <span>Découvrir</span>
                <i className="ri-arrow-right-line" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EcosystemSection;